import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import { getCookie } from "@workspace/cookies/browser";

/**
 * The current user, as fetched on the server by `PagesRouterAdapter`
 * (`getUser`, which already applies the Sportsbet preferences' currency).
 */
const useFetchUser = () => {
  const { user: appRouterUser } = useAppContext();
  const token = getCookie("token");
  const userPreferenceId = getCookie("userPreferenceId");
  const { id, user, profile, countryInfo, walletCurrency } =
    appRouterUser ?? {};

  return {
    id,
    user,
    profile,
    countryInfo,
    walletCurrency: walletCurrency as Maybe<CashierCurrency>,
    token,
    userPreferenceId,
  };
};

export default useFetchUser;
